/**
 * src/components/promos-page/PromoCard.js
 * Props: { promo }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'
import { TAG_COLORS } from '@/db/promos.db.js'

define('PromoPageCard', ({ promo }) => {
    const { businessId, business, image, tag, title, description, expires } = promo
    const color = TAG_COLORS[tag] || { bg: '#f3f4f6', color: '#374151' }

    const badge = h('span', { className: 'promo-card__tag' }, tag)
    badge.style.background = color.bg
    badge.style.color       = color.color

    return h('div', { className: 'promo-card' },
        h('div', { className: 'promo-card__img-wrap' },
            h('img', { src: image, alt: title, className: 'promo-card__img', loading: 'lazy' }),
            badge
        ),
        h('div', { className: 'promo-card__body' },
            h('p',  { className: 'promo-card__business' }, business),
            h('h3', { className: 'promo-card__title' }, title),
            h('p',  { className: 'promo-card__desc' }, description),
            expires
                ? h('p', { className: 'promo-card__expires' }, `⏳ Válido hasta: ${expires}`)
                : null
        ),
        h('div', { className: 'promo-card__footer' },
            h('a', {
                href:      `/promociones/${promo.id}`,
                className: 'promo-card__btn'
            }, 'Ver promoción →')
        )
    )
})
